import { render, staticRenderFns } from "./CustomerActivities.vue?vue&type=template&id=1755e892&scoped=true"
import script from "./CustomerActivities.vue?vue&type=script&lang=js"
export * from "./CustomerActivities.vue?vue&type=script&lang=js"
import style0 from "./CustomerActivities.vue?vue&type=style&index=0&id=1755e892&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1755e892",
  null
  
)

export default component.exports